module.exports = __webpack_public_path__ + "static/media/23_tn.4d3280fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/23_tn.jpg
// module id = 453
// module chunks = 0